import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";
import { DelegatedObservableArrayChangeListenner, ObservableArray, ObservableArrayChangeListenner } from "../../../observableList";
import { BindedView } from "../utilities";
import { ComponentView } from "../../..";

export class ItemsSourceHtmlBridgePrototype extends HtmlBridgePrototype{


    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ItemsSourceHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class ItemsSourceHtmlBridge extends HtmlBridge{
    
    private element:Element;
    private bindingPrototype : BindingPrototype;
    private codeBehind : any;
    private binding:IBinding;
    private changeListenner:ObservableArrayChangeListenner;
    private currentViews:Map<ViewModel,BindedView>;

    public set items(v: ObservableArray<ViewModel>) { 
        if(this.items){
            this.items.removeChangeListenner(this.changeListenner);
        }
        this._items = v; 
        if(this.items){
            this.changeListenner = new DelegatedObservableArrayChangeListenner(this,this.listChanged);
            this.items.addChangeListenner(this.changeListenner);
            this.listChanged(this.items);
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    
    constructor(prototype:ItemsSourceHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.currentViews = new Map<ViewModel,BindedView>();
    }
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.codeBehind = view;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'items'));
    }
    
    private listChanged(list:ObservableArray<ViewModel>){
        let set = new Set(list);
        let removingElements = [...this.currentViews.keys()].filter(x=>set.has(x)==false);
        let newElements = list.filter(x=>this.currentViews.has(x)==false);
        newElements.forEach(x=>{
            let bindedView = new BindedView(this.bindingPrototype.getViewSelectorFunction(this.codeBehind));
            bindedView.update(x);
            this.currentViews.set(x,bindedView)
        });
        let grandParent = this.element.parentNode;
        let nextSibling = this.element.nextSibling;
        this.element.remove();

        removingElements.forEach(x=>{
            let binded = this.currentViews.get(x);
            binded.element.remove();
            binded.release();
            this.currentViews.delete(x);
        });

        let nextNode = null;
        for(let i=list.length-1;i>=0;i--){
            let vm = list[i];
            let node = this.currentViews.get(vm); 
            if(node.element.nextSibling!=nextNode || i==list.length-1)
                this.element.insertBefore(node.element,nextNode);
            nextNode = node.element;
        }
        grandParent.insertBefore(this.element,nextSibling);
        newElements.forEach(x=>{
            let view = this.currentViews.get(x).view;
            if(view instanceof ComponentView)
                view.attachedToView();
        })
        
    }

    public release(){
        this.binding.release();
    }
}